__turbopack_context__.v({
  "closeButton": "LoggedOutContent-module-scss-module__RmurxG__closeButton",
  "content": "LoggedOutContent-module-scss-module__RmurxG__content",
  "createAccountButton": "LoggedOutContent-module-scss-module__RmurxG__createAccountButton",
  "description": "LoggedOutContent-module-scss-module__RmurxG__description",
  "header": "LoggedOutContent-module-scss-module__RmurxG__header",
  "heading": "LoggedOutContent-module-scss-module__RmurxG__heading",
  "signInButton": "LoggedOutContent-module-scss-module__RmurxG__signInButton",
});
